import type { AuditEntry } from "../api";

// Human labels + one-line renderings for the audit log (ADR 0160). Kept in one
// place so the Overview recent-activity strip and the full Audit screen read
// identically.

export const AUDIT_ACTION_LABEL: Record<string, string> = {
  "impersonation.start": "Impersonation started",
  "impersonation.end": "Impersonation ended",
  "entitlement.revoke": "Entitlement revoked",
  "user.password_reset": "Password reset",
  "user.role_grant": "Role granted",
  "user.role_revoke": "Role revoked",
  "user.superadmin_grant": "Super-admin granted",
  "user.superadmin_revoke": "Super-admin revoked",
  "user.delete": "User deleted",
  "cave.create": "Cave created",
  "cave.archive": "Cave archived",
  "cave.delete": "Cave deleted",
  "cave.legend_change": "Legend reassigned",
  "recording.rearm": "Recording re-armed",
  "event.cancel": "Event cancelled",
  "event.rename": "Event renamed",
  "event.reorder": "Events reordered",
  "ticket.delete": "Ticket type deleted",
  "ticket.rename": "Ticket type renamed",
  "ticket.reorder": "Ticket types reordered",
};

/** A readable one-liner: who did what to which object, and (if impersonating) that fact. */
export function auditLine(e: AuditEntry): string {
  const verb = AUDIT_ACTION_LABEL[e.action] ?? e.action;
  const actor = e.actor || "someone";
  const target = e.objectDisplay || e.objectId;
  let line = target ? `${verb}: ${target}` : verb;
  line = `${actor} — ${line}`;
  if (e.reason) line += ` · “${e.reason}”`;
  if (e.impersonating) line += " (while impersonating)";
  return line;
}
